import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  overviewButtonText: {
    id: 'courseware.course.sidebar.button.overview',
    defaultMessage: 'Project Menu',
    description: 'Sidebar toggle button text',
  },
  courseProgress: {
    id: 'courseware.course.sidebar.course.progress',
    defaultMessage: 'Progress',
    description: 'Sidebar toggle button text',
  },
  courseProgressComplete: {
    id: 'courseware.course.sidebar.course.progress.complete',
    defaultMessage: '{progress}% Complete',
    description: 'Sidebar toggle button text',
  },
  courseOverviewLinkText: {
    id: 'courseware.course.sidebar.link.overview',
    defaultMessage: 'Overview',
    description: 'Course overview link text',
  },
  courseTrackingLinkText: {
    id: 'courseware.course.sidebar.link.coordinator.tracking',
    defaultMessage: 'Coordinator Tracking',
    description: 'Course coodinator tracking link text',
  },
  loadingSequence: {
    id: 'learn.loading.learning.sequence',
    defaultMessage: 'Loading learning sequence...',
    description: 'Message when learning sequence is being loaded',
  },
});

export default messages;
